var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/972ca6ecf5372d0b7a4bbe9917f46e7c.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a3e260f3356b3049d31724b14b63db55.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b47664141f86a5abcac4672987f05a7e.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fa4eeb877f69c9a8559d0788dbd9a160.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    